import { CustomListItemId, CustomListKey, HomeCareLeadId } from "@sp-crm/core";
import React from "react";
import { useCustomList } from "store/selectors/bridge";
import { ClientMapContactActions } from "./client-map-contact-actions";
import { ClientMapStatusPill } from "./client-map-status-pill";

interface ClientMapPinActionsProps {
    leadId: HomeCareLeadId;
    statusListItemId: CustomListItemId | null;
}

export const ClientMapPinActions: React.FC<ClientMapPinActionsProps> = props => {
    const { leadId, statusListItemId } = props;
    const { getListItemName } = useCustomList(CustomListKey.HomeCareLeadStatus);

    return (
        <div className="space-y-1">
            {statusListItemId ? (
                <div className="py-0.5">
                    <ClientMapStatusPill statusName={getListItemName(statusListItemId)} />
                </div>
            ) : null}
            <ClientMapContactActions leadId={leadId} />
        </div>
    );
};
